// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"
import ScrollController from "./scroll_controller"
import KvController from "./kv_controller"
import HeaderController from "./header_controller"
import InvitationFormController from "./invitation_form_controller"
import ScheduleController from "./schedule_controller"
import BrandController from "./brand_switch_controller.js"
import SwiperController from "./swiper_controller"
import ListController from "./list_controller"
import SlideGalleryController from "./slide_gallery_controller"
import SelectDropdownController from "./select_dropdown_controller"

application.register("scroll", ScrollController)
application.register("kv", KvController)
application.register("header", HeaderController)
application.register("invitation-form", InvitationFormController)
application.register("schedule", ScheduleController)
application.register("brand", BrandController)
application.register("swiper", SwiperController)
application.register("list", ListController)
application.register("slide-gallery", SlideGalleryController)
application.register("select-dropdown", SelectDropdownController)

